// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1v-0";
export var spinnerContainer = "_1v-1";